/** Models */
import { DsPinStatus } from '../models/ds-pin-status';

/** Constants */
import { DS_PIN_STATUS } from '../constants/ds-pin-status.constant';

/**
 * Replace api response model by the custom label model.
 *
 * @param statusList list of custom status
 * @returns BydModel<DsPinStatus>
 */
export function getCustomPinStatus(statusList: DsPinStatus[]): DsPinStatus[] {
  return DS_PIN_STATUS.map((item) => {
    return { ...item, ...statusList.find((status) => status.id === item.id) };
  });
}
